import './App.css';
import Platform from './components/Platform';

function App() {
  return (
    <div className="App d-flex justify-content-center align-items-center p-0">
      <Platform />
    </div>
  );
}

export default App;
